import { Box, Typography, useTheme } from '@mui/material'
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded'
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded'
import RedeemRoundedIcon from '@mui/icons-material/RedeemRounded'
import { keyframes } from '@mui/system'
import { Link } from 'react-router-dom'

const marquee = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`

const ANNOUNCEMENTS = [
  { icon: LocalShippingOutlinedIcon, text: 'Free shipping on orders over ₹999', link: '/products' },
  { icon: VerifiedRoundedIcon, text: 'Authentic ethnic wear — 100% guaranteed', link: '/products' },
  { icon: SupportAgentRoundedIcon, text: 'Customer support — Mon–Sat 9am–7pm IST', link: '/support' },
  { icon: RedeemRoundedIcon, text: 'Delivery across India in 3–7 business days', link: '/products' },
]

// Duplicate for seamless loop
const items = [...ANNOUNCEMENTS, ...ANNOUNCEMENTS]

const TopInfoBar = () => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'

  return (
    <Box sx={{
      height: 36,
      background: isDark
        ? 'linear-gradient(135deg, #312E81 0%, #1E1B4B 100%)'
        : 'linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)',
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
    }}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        width: 'max-content',
        animation: `${marquee} 30s linear infinite`,
        gap: 6,
        '&:hover': { animationPlayState: 'paused' },
      }}>
        {items.map((item, i) => {
          const Icon = item.icon
          const inner = (
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.75,
              color: 'rgba(255,255,255,0.92)',
              whiteSpace: 'nowrap',
              flexShrink: 0,
              transition: 'opacity 0.15s',
              '&:hover': { opacity: 0.85 },
            }}>
              <Icon sx={{ fontSize: 14 }} />
              <Typography variant="caption" sx={{
                fontWeight: 600,
                letterSpacing: '0.02em',
                fontSize: '0.7rem',
                textTransform: 'uppercase',
              }}>
                {item.text}
              </Typography>
            </Box>
          )
          return (
            <Box key={i} component={Link} to={item.link} sx={{ textDecoration: 'none', color: 'inherit' }}>
              {inner}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

export default TopInfoBar
